<div class="data-lens">
  <div class="page-header">
    <div class="subtitle">
      <span [innerHTML]="'dataLensPage.subtitle' | labelsProvider"></span>
      <img
        class="icon-field"
        src="assets/images/common/info.svg"
        height="16px"
        [matTooltip]="'dataLensPage.tooltip' | labelsProvider"
        matTooltipPosition="above"
      />
    </div>
  </div>

  <div class="table-actions">
    <app-data-layer-filters [pageFilters]="pageFilters" />
  </div>

  <div class="table-header">
    @if (totalItems() > 0) {
      <div class="resources-amount">{{ totalItems() | number }} items found</div>
    }
    <div class="table-header-right">
      <!-- TODO: Add columns selection component -->
      <!-- <app-columns-selection [columns]="columns()" [pageName]="pageName"/> -->
    </div>
  </div>

  <div class="table">
    <app-data-layer-vertical-filters
      [ngClass]="{ 'filters-all': isFiltersMenuOpen() }"
      (optionOnSelection)="tablesFiltersChange($event)"
      [pageFilters]="pageFilters"
      [isFiltersMenuOpen]="isFiltersMenuOpen()"
      (filtersOnMenuStateChange)="isFiltersMenuOpen.set($event)"
    />

    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen() ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="data-lens"
      [data$]="currentPage$"
      [rowsPerPage]="defaultPageSize()"
      [columns]="columns()"
      [isLoading]="isLoading() === true"
      [sortedColumn$]="pageFilters.sortedColumn$"
      [pageInfo]="pageInfo()"
      [expandFilterResultControl]="expandFilterResultControl"
      (pageOnChange)="onPagination($event)"
      (rowSelected)="rowSelected($event)"
      (rowUnselected)="rowUnselected()"
      tableNotFoundText="You don't have any data lens items"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
      [withRowSelection]="true"
      [withCheckboxSelection]="false"
      [tabelWithIcon]="false"
    />
  </div>
</div>
